window.Handlebars.registerHelper(
  'integer',
  text => new window.Handlebars.SafeString(String(parseInt(text, 10)))
);
